// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Liechtenstein */
const LI =
  /^(?:(?:6(?:(?:4[5-9]|5\d)\d|6(?:[024-68]\d|1[01]|3[7-9]|7[02]))\d|7(?:[37-9]\d|42|56))\d{4})$/;

export default LI;
